import { createFileRoute, Navigate } from "@tanstack/react-router";
import type { JSX } from "react";

const SuperviseIndexPage = (): JSX.Element => <Navigate to="/supervise/activity" />;

export const Route = createFileRoute("/_app/supervise/")({
	component: SuperviseIndexPage,
});
